import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReceitaForm from "@/components/ReceitaForm";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { logError } from "@/lib/logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EditarReceita = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [receita, setReceita] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carregarReceita = async () => {
      try {
        const response = await axios.get(`${API}/receitas/${id}`);
        setReceita(response.data);
      } catch (error) {
        logError("Erro ao carregar receita:", error);
        toast.error("Erro ao carregar receita");
        navigate("/receitas");
      } finally {
        setLoading(false);
      }
    };

    carregarReceita();
  }, [id, navigate]);

  const handleSubmit = async (data, pendingFiles = []) => {
    try {
      await axios.put(`${API}/receitas/${id}`, data);
      toast.success("Receita atualizada com sucesso!");
      navigate("/receitas");
    } catch {
      toast.error("Erro ao atualizar receita");
    }
  };

  if (loading) {
    return (
      <div className="text-center py-12" data-testid="loading-indicator">
        <p className="text-slate-500">Carregando...</p>
      </div>
    );
  }

  return (
    <div data-testid="editar-receita-container">
      <Card className="bg-white border border-slate-200 shadow-sm">
        <CardHeader className="bg-slate-50 border-b border-slate-200">
          <CardTitle className="text-2xl font-semibold text-slate-900">Editar Receita</CardTitle>
          <p className="text-sm text-slate-500 mt-2">
            Atualize os campos desejados. Nenhum campo é obrigatório.
          </p>
        </CardHeader>
        <CardContent className="pt-6">
          <ReceitaForm
            initialData={receita}
            onSubmit={handleSubmit}
            onCancel={() => navigate("/receitas")}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default EditarReceita;